<template>
  <div />
</template>

<script setup>
import { onMounted } from 'vue';

import { useRouter } from 'vue-router';
import { parse as parseToken } from '@/utils/token-parser';

const router = useRouter();

const navigate = async (token, parsed) => {
  if (parsed.type === 'VIEW_ORDER') {
    await router.push({
      name: 'OrderView',
      params: {
        id: parsed.meta.id,
      },
      query: {
        token,
      },
    });
  } else if (parsed.type === 'HOME') {
    await router.push({
      name: 'Home',
      params: {
        id: parsed.meta.id,
      },
      query: {
        token,
      },
    });
  }
};

onMounted(async () => {
  const search = new URLSearchParams(window.location.search);
  const sessionToken = search.get('token');
  const parsed = parseToken(sessionToken);
  navigate(sessionToken, parsed);
});

</script>
